module.exports = __webpack_public_path__ + "img/kf-head.772db95a.png";